import React, { ReactElement } from 'react';
import { sessionApi } from '../../../../../../redux/views/session-view/session/api/api';
import { ActionsBarCenterContainerProps } from './container';
import { ActionsBarCenter } from '.';

type ConnectedDCloudActionsBarCenterProps = ActionsBarCenterContainerProps &
  FetchSessionArgs;

export function ConnectedDCloudActionsBarCenter({
  setLeftPanelType,
  setShowEndSessionModal,
  setShowRenameSessionModal,
  setShowResetSessionModal,
  setShowSaveAndEndSessionModal,
  isSessionExpired,
  sessionUid,
  versionUid,
  isSessionActiveTabTopology,
}: ConnectedDCloudActionsBarCenterProps): ReactElement {
  const { actions, data, isError, isLoading } =
    sessionApi.endpoints.getSession.useQueryState(
      {
        sessionUid,
        versionUid,
      },
      {
        selectFromResult: ({ data, isLoading, isError }) => ({
          actions: data?._links,
          data: data?.sessionDetails,
          isError,
          isLoading,
        }),
      },
    );

  return (
    <ActionsBarCenter
      actions={actions}
      setLeftPanelType={setLeftPanelType}
      setShowEndSessionModal={setShowEndSessionModal}
      setShowRenameSessionModal={setShowRenameSessionModal}
      setShowResetSessionModal={setShowResetSessionModal}
      setShowSaveAndEndSessionModal={setShowSaveAndEndSessionModal}
      isSessionExpired={isSessionExpired}
      sessionDetails={data}
      isSessionDetailsLoading={isError || isLoading}
      isSessionActiveTabTopology={isSessionActiveTabTopology}
    />
  );
}
